import React, {Component} from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {gaEventWithUserIdLabel, gaPageView, LOG_OUT, MATCH_RATE_SLIDER_MARKS, minMatchRateFormatter,} from "../constants";
import {UserAction} from "../actions/UserAction";
import {Button, Checkbox, message, Modal, Popconfirm, Popover, Select, Slider, Spin, Table, Tag, Tooltip, Upload,} from "antd";
import {
    CloudDownloadOutlined,
    DeleteOutlined,
    DownloadOutlined,
    EllipsisOutlined,
    InfoCircleOutlined,
    ReloadOutlined,
    UploadOutlined,
} from "@ant-design/icons";
import ExcelSearchService from "../services/excelSearch.service";
import excelSearchService from "../services/excelSearch.service";
import i18n from "i18next";
import AuthService from "../services/auth.service";
import $ from "jquery";
import fileDownload from "js-file-download";

import guideEn from "../assets/files/ExcelSearchGuide.pdf"
import guideTr from "../assets/files/ExcelSearchRehberi.pdf"
import entityIdEn from "../assets/files/Search Sanctions Entity ID.xlsx";
import entityNameEn from "../assets/files/Search Sanctions Entity Name.xlsx";
import entityIdTr from "../assets/files/Search Sanctions Kurum ID.xlsx";
import entityNameTr from "../assets/files/Search Sanctions Kurum Adı.xlsx";
import personIdEn from "../assets/files/Search Sanctions Person ID.xlsx";
import personNameEn from "../assets/files/Search Sanctions Person Name.xlsx";
import personIdTr from "../assets/files/Search Sanctions Kişi ID.xlsx";
import personNameTr from "../assets/files/Search Sanctions Kişi Adı.xlsx";

class ExcelSearch extends Component {
    constructor(props) {
        super(props);

        this.state = {
            minMatchRate: 80,
            spinnings: [],
            fileList: [],
            uploading: false,
            includeLocalSanctions: false,
            includePeP: false,
            excelFile: "",
            columns: [
                {
                    title: i18n.t("multi_search_column_search_date"),
                    dataIndex: "searchDate",
                    key: "searchDate",
                    align: "center",
                    render: (searchDate) => searchDate,
                },
                {
                    title: i18n.t("multi_search_column_file_name"),
                    dataIndex: "fileName",
                    key: "fileName",
                    render: (fileName, record) => this.fileNameComponent(record),
                },
                {
                    title: i18n.t("multi_search_column_searcher_name"),
                    dataIndex: "searcherName",
                    key: "searcherName",
                    align: "center",
                },
                {
                    title: i18n.t("multi_search_column_search_status"),
                    key: "searchStatus",
                    dataIndex: "searchStatus",
                    align: "center",
                    render: (status) => (
                        <Tag color={this.getColor(status)} key={status}>
                            {i18n.t("excel_search_status_" + status)}
                        </Tag>
                    ),
                },
                {
                    title: i18n.t("multi_search_column_result"),
                    key: "resultFileId",
                    dataIndex: "resultFileId",
                    align: "center",
                    render: (resultFileId, record) =>
                        this.resultFileNameComponent(record),
                },
                {
                    title: (
                        <Button
                            size="small"
                            onClick={this.reloadTableData}
                            className="reload-data-button colorized-to-blue"
                        >
                            <ReloadOutlined/>
                        </Button>
                    ),
                    key: "actions",
                    dataIndex: "actions",
                    align: "center",
                },
            ],
            data: [],
        };

        this.pullExcelSearchList();
    }

    fileNameComponent(record) {
        let fileId = record.fileId;
        let fileName = record.fileName;

        return fileId ? (
            <Spin spinning={!!this.state.spinnings[fileId]}>
                <a
                    onClick={(event) => {
                        this.downloadExcelFile(fileId, fileName, event);
                    }}
                    href="#"
                >
                    {fileName}
                </a>
            </Spin>
        ) : (
            fileName
        );
    }

    resultFileNameComponent(record) {
        let resultFileId = record.resultFileId;
        let resultFileName = record.resultFileName;

        return resultFileId ? (
            <Spin spinning={!!this.state.spinnings[resultFileId]}>
                <a
                    onClick={(event) => {
                        this.downloadExcelFile(resultFileId, resultFileName, event);
                    }}
                    href="#"
                >
                    <CloudDownloadOutlined/>
                    {i18n.t("multi_search_download_result")}
                </a>
            </Spin>
        ) : (
            // <label>{record.errorDetail}</label>
            <label/>
        );
    }

    downloadExcelFile(fileId, fileName, event) {
        this.spinning(fileId);

        ExcelSearchService.downloadFile(fileId).then(
            (response) => {
                this.unSpinning(fileId);

                if (response.data) fileDownload(response.data, fileName);
                else message.error(i18n.t("global_error"));
            },
            (error) => {
                this.unSpinning(fileId);

                if (error.response && error.response.status === 401) {
                    AuthService.logout();
                    this.props.userAction(LOG_OUT);

                    message.error(i18n.t("login_expired"));
                } else {
                    gaEventWithUserIdLabel(
                        "ExcelSearchService.downloadFile Error - " + i18n.t("global_error")
                    );
                    message.error(i18n.t("global_error"));
                }
            }
        );

        event.preventDefault();
    }

    getFile = (fileName, lang) => {
        const files = {
            en: {
                entityId: {
                    name: "Search Sanctions Entity ID.xlsx",
                    file: entityIdEn,
                },
                entityName: {
                    name: "Search Sanctions Entity Name.xlsx",
                    file: entityNameEn,
                },
                personName: {
                    name: "Search Sanctions Person Name.xlsx",
                    file: personNameEn,
                },
                personId: {
                    name: "Search Sanctions Person ID.xlsx",
                    file: personIdEn,
                },
            },
            tr: {
                entityId: {
                    name: "Search Sanctions Kurum ID.xlsx",
                    file: entityIdTr,
                },
                entityName: {
                    name: "Search Sanctions Kurum Adı.xlsx",
                    file: entityNameTr,
                },
                personName: {
                    name: "Search Sanctions Kişi Adı.xlsx",
                    file: personNameTr,
                },
                personId: {
                    name: "Search Sanctions Kişi ID.xlsx",
                    file: personIdTr,
                },
            },
        };
        return files[lang][fileName];
    };

    downloadExcelFileUpdated = (fileName) => {
        const link = document.createElement("a");
        const file = this.getFile(fileName, this.props.common.lang);
        link.href = file.file;
        link.download = file.name;
        link.click();
    };

    spinning(fileId) {
        let spinnings = this.state.spinnings;
        spinnings[fileId] = true;

        this.setState({
            spinnings: spinnings,
        });
    }

    unSpinning(fileId) {
        let spinnings = this.state.spinnings;
        spinnings[fileId] = false;

        this.setState({
            spinnings: spinnings,
        });
    }

    deleteExcel = (id) => {
        excelSearchService.deleteExcel(id)
            .then(
                response => {
                    if (response.data === true) {
                        this.reloadTableData();
                    } else {
                        message.error(i18n.t('global_error'))
                    }
                },
                error => {
                    if (error.response && error.response.status === 401) {
                        AuthService.logout()
                        this.props.userAction(LOG_OUT)

                        message.error(i18n.t('login_expired'))
                    } else {
                        message.error(i18n.t('global_error'))
                    }
                }
            )
    }

    researchExcel = (id) => {
        excelSearchService.researchExcel(id).then(
            response => {
                if (response.data === true) {
                    this.reloadTableData();
                }
            },
            error => {
                if (error.response && error.response.status === 401) {
                    AuthService.logout()
                    this.props.userAction(LOG_OUT)

                    message.error(i18n.t('login_expired'))
                } else {
                    message.error(i18n.t('global_error'))
                }
            }
        )
    }

    onDateChange = (value, dateString) => {
        console.log('Formatted Selected Time: ', dateString);
    };

    pullExcelSearchList() {
        ExcelSearchService.findAll().then(
            (response) => {
                this.setState({reloading: false});
                if (response.data) {
                    let items = response.data.items;
                    items = items.map((item) => {
                        const fileName = item.fileName;

                        if (fileName.length >= 20) {
                            item.fileName =
                                fileName.substring(0, 15) +
                                "..." +
                                fileName.substring(fileName.length - 10);
                        }
                        item.searchDate = item.searchDate.substring(
                            0,
                            item.searchDate.length - 3
                        );
                        item.actions = (
                            <Popover
                                placement="right"
                                content={
                                    <div className="excel-actions-container">
                                        {/* <Popover content={
                            <>
                            <DatePicker
                            showTime={{
                                format: 'HH:mm',
                            }}
                            format="YYYY-MM-DD HH:mm"
                            onChange={this.onDateChange}
                            onOk={val => console.log("added schedule")}
                            />
                            </>
                        }>
                        <Button className="excel-action-button colorized-to-blue"><ScheduleOutlined /> {i18n.t("schedule_excel_search")}</Button>
                        </Popover> */}
                                        {/* <Button onClick={val => this.researchExcel(item.id)} className="excel-action-button colorized-to-blue"><CheckCircleOutlined /> {i18n.t("redo_excel_search")}</Button> */}
                                        <Popconfirm
                                            title={<p className="colorized-to-blue">{i18n.t("confirm_excel_delete")}</p>}
                                            onConfirm={val => this.deleteExcel(item.id)}
                                            onCancel={"cancel"}
                                            okText={i18n.t("yes")}
                                            cancelText={i18n.t("no")}
                                        >
                                            <Button className="excel-action-button colorized-to-blue"><DeleteOutlined/> {i18n.t("delete_excel_search")}</Button>
                                        </Popconfirm>
                                    </div>
                                }
                                style={{
                                    width: 220,
                                }}
                                onChange={this.handleExcelFileChange}
                            >
                                <Button size="small" className="colorized-to-blue">
                                    <EllipsisOutlined/>
                                </Button>
                            </Popover>
                        );

                        return item;
                    });
                    if (items) {
                        this.setState({
                            data: items,
                        });
                    }
                }
            },
            (error) => {
                this.setState({reloading: false});
                if (error.response && error.response.status === 401) {
                    AuthService.logout();
                    this.props.userAction(LOG_OUT);

                    message.error(i18n.t("login_expired"));
                } else {
                    gaEventWithUserIdLabel(
                        "ExcelSearchService.findAll Error - " + i18n.t("global_error")
                    );
                    message.error(i18n.t("global_error"));
                }
            }
        );
    }

    componentDidMount() {
        gaPageView();
    }

    getGuidePDF() {
        const lang = this.props.common.lang;

        return lang == "tr" ? guideTr : guideEn

    }

    reloadTableData = () => {
        this.setState({reloading: true});

        setTimeout(
            function () {
                this.pullExcelSearchList();
            }.bind(this),
            751
        );
    };

    handleUpload = () => {
        this.setState({uploading: true});

        setTimeout(
            function () {
                this.upload(this.reloadTableData);
            }.bind(this),
            751
        );
    };

    upload = (reloadTableData) => {
        const {fileList, minMatchRate, includeLocalSanctions, includePeP} = this.state;

        const formData = new FormData();
        formData.append("file", fileList[0]);

        ExcelSearchService.upload(formData, minMatchRate, includeLocalSanctions, includePeP).then(
            (response) => {
                this.setState({fileList: [], uploading: false});
                $(".ant-upload-select").fadeIn(13);

                if (response.data.success === true) {
                    Modal.success({
                        centered: true,
                        content: i18n.t("multi_search_started"),
                        onOk() {
                            reloadTableData()
                        },
                    });

                    this.pullExcelSearchList();
                } else {
                    gaEventWithUserIdLabel(
                        "ExcelSearchService.upload Data Error - " + i18n.t("global_error")
                    );
                    message.error(i18n.t("global_error"));
                }
            },
            (error) => {
                this.setState({uploading: false});

                if (error.response && error.response.status === 401) {
                    AuthService.logout();
                    this.props.userAction(LOG_OUT);

                    message.error(i18n.t("login_expired"));
                } else {
                    gaEventWithUserIdLabel(
                        "ExcelSearchService.upload Error - " + i18n.t("global_error")
                    );
                    message.error(i18n.t("global_error"));
                }
            }
        );
    };

    handleIncludeLocalSanctionsChecked = (e) => {
        this.setState({includeLocalSanctions: e.target.checked});
    };

    handleIncludePePChecked = (e) => {
        this.setState({includePeP: e.target.checked});
    };

    handleMinMatchRate = (minMatchRate) => {
        this.setState({minMatchRate: minMatchRate});
    };

    getColor(status) {
        return status === "FAILED"
            ? "red"
            : status === "SUCCESS"
                ? "green"
                : "blue";
    }

    handleExcelFileChange = (value) => {
        this.downloadExcelFileUpdated(value);
    };

    render() {
        const {uploading, fileList, columns, data, minMatchRate, includeLocalSanctions, includePeP} = this.state;
        const radioStyle = {lineHeight: "30px"};

        const showLocalSanctions = AuthService.hasRole("LOCAL_LIST");
        const showPeP = AuthService.hasRole("PEP");

        const props = {
            multiple: false,
            accept: ".xls,.xlsx",
            listType: "picture",
            onRemove: (file) => {
                $(".ant-upload-select").fadeIn(1313);

                this.setState((state) => {
                    const index = state.fileList.indexOf(file);
                    const newFileList = state.fileList.slice();
                    newFileList.splice(index, 1);
                    return {
                        fileList: newFileList,
                        uploading: false,
                    };
                });
            },
            beforeUpload: (file) => {
                this.setState((state) => ({
                    fileList: [...state.fileList, file],
                }));

                $(".ant-upload-select").fadeOut(13);

                return false;
            },
            fileList,
        };

        return (
            <>
                <section className="ms-section pb-20">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="form-box-excel align-items-center custom-box-shadow">
                                <div className="row justify-content-center">
                                    <div className="excel-settings-container">
                                        <Upload {...props}>
                                            <Button className="upload-excel-btn colorized-to-blue">
                                                <UploadOutlined/>
                                                {i18n.t("multi_search_select_file")}
                                            </Button>
                                        </Upload>
                                        <div className="row search-param-row">
                                            <div className="col-sm-12 col-md-4 search-param-label">
                                                <span>{i18n.t("minMatchRate")}</span>
                                            </div>
                                            <div className="col-sm-12 col-md-8">
                                                <Slider
                                                    min={60}
                                                    max={100}
                                                    defaultValue={minMatchRate}
                                                    marks={MATCH_RATE_SLIDER_MARKS}
                                                    onChange={this.handleMinMatchRate}
                                                    tipFormatter={minMatchRateFormatter}
                                                />
                                            </div>
                                        </div>

                                        {showLocalSanctions && (
                                            <div className="row search-param-row">
                                                <div className="col-8 col-md-4 search-param-label">
                                                    <span>{i18n.t("includeLocalSanctions")}</span>
                                                </div>
                                                <div className="col-4 col-md-8">
                                                    <Checkbox
                                                        id="includeLocalSanctions"
                                                        name="includeLocalSanctions"
                                                        size="large"
                                                        checked={includeLocalSanctions}
                                                        onChange={this.handleIncludeLocalSanctionsChecked}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                        {showPeP && (
                                            <div className="row search-param-row">
                                                <div className="col-8 col-md-4 search-param-label">
                                                    <span>{i18n.t("includePeP")}</span>
                                                </div>
                                                <div className="col-4 col-md-8">
                                                    <Checkbox
                                                        id="includePeP"
                                                        name="includePeP"
                                                        size="large"
                                                        checked={includePeP}
                                                        onChange={this.handleIncludePePChecked}
                                                    />
                                                </div>
                                            </div>
                                        )}
                                    </div>

                                    <div className="guide-btn-container">
                                        <a href={this.getGuidePDF()} target="_blank">
                                            <Tooltip
                                                placement="left"
                                                title={i18n.t("guide_for_use")}
                                                color={"204f79"}
                                                key={"coloredTT1"}
                                            >
                                                <Button size="small" className="colorized-to-blue">
                                                    <InfoCircleOutlined/>
                                                </Button>
                                            </Tooltip>
                                        </a>
                                        <Popover
                                            placement="left"
                                            content={
                                                <Select
                                                    value={i18n.t("please_select_schema")}
                                                    style={{
                                                        width: 220,
                                                    }}
                                                    onChange={this.handleExcelFileChange}
                                                >
                                                    {[
                                                        "personName",
                                                        "entityName",
                                                        "personId",
                                                        "entityId",
                                                    ].map((item) => {
                                                        return (
                                                            <Select.Option key={item} value={item}>
                                                                {i18n.t("excel_file_" + item)}
                                                            </Select.Option>
                                                        );
                                                    })}
                                                </Select>
                                            }
                                            color={"204f79"}
                                            key={"coloredTT2"}
                                            trigger="hover"
                                        >
                                            <Button size="small" className="colorized-to-blue">
                                                {<DownloadOutlined/>}
                                            </Button>
                                        </Popover>
                                    </div>
                                </div>

                                {
                                    <>
                                        <div className="row justify-content-center pt-15">
                                            <div className="col-12 col-sm-8">
                                                <div className="text-center">
                                                    {fileList.length > 0 && (
                                                        <Button
                                                            className="custom-button"
                                                            type="primary"
                                                            onClick={this.handleUpload}
                                                            loading={uploading}
                                                            style={{marginTop: 16}}
                                                        >
                                                            {uploading
                                                                ? i18n.t("multi_search_uploading")
                                                                : i18n.t("multi_search_start_search")}
                                                        </Button>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                            </div>
                        </div>

                        {
                            <div className="row justify-content-center">
                                <div className="form-box-table align-items-center custom-box-shadow">
                                    <div className="d-flex flex-column align-items-center">
                                        <Table
                                            className="excel-search-data-table"
                                            loading={this.state.reloading}
                                            //title={() => i18n.t('excel_search_table_desc')}
                                            columns={columns}
                                            dataSource={data}
                                        />
                                    </div>
                                </div>
                            </div>
                        }
                    </div>
                </section>
            </>
        );
    }
}

function mapStateToProps(state) {
    return {
        user: state.user,
        common: state.common,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(
        {
            userAction: UserAction,
        },
        dispatch
    );
}

export default connect(mapStateToProps, mapDispatchToProps)(ExcelSearch);
